<template>
  <nav>
    <v-app-bar
      app
      color="#f8f3eb"
      sticky
      :class="{ navbarNarrow: !editable, navbarBroad: editable }"
      v-if="navTopBar && !readOnly && editableUse && isAuthenticated"
    >
      <v-toolbar-title></v-toolbar-title>
      <v-spacer></v-spacer>

      <v-icon
        id="titleIcon"
        v-show="editableUse"
        variant="outline-primary"
        @click="editDetail()"
        >mdi-pencil</v-icon
      >
      <v-icon
        id="titleIcon"
        v-if="editableUse"
        variant="outline-primary"
        size="sm"
        @click="deleteDetail()"
        >mdi-delete</v-icon
      >
      <v-icon
        id="titleIcon"
        v-if="editable"
        variant="outline-primary"
        size="sm"
        @click="editDetailCancel()"
        >mdi-cancel</v-icon
      >
    </v-app-bar>

    <!-- SECTION: 옆쪽 Drawer
      ====================================================================== -->

    <v-navigation-drawer
      id="leftNavigation"
      ref="leftNavigation"
      app
      color="#f8f3eb"
      v-model="drawer"
      :mini-variant.sync="mini"
    >
      <div class="text-right">
        <v-btn class="mr-3 mt-3" icon text>
          <template v-if="!mini">
            <template v-if="!isDesktop">
              <v-icon @click="drawer = false" id="icon" large
                >mdi-menu-left</v-icon
              >
            </template>
            <template v-else>
              <v-icon @click="mini = true" id="icon" large
                >mdi-menu-left</v-icon
              >
            </template>
          </template>
          <template v-else>
            <v-icon id="icon" large>mdi-menu-right</v-icon>
          </template>
        </v-btn>
      </div>
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img src="../assets/1.jpg"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title black--text">
              Darrick World
            </v-list-item-title>
            <v-list-item-subtitle class="black--text"
              >Private Web Application</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <hr class="ma-3 black my-hr" />
      <v-list nav dense>
        <div :key="link.text" v-for="link in links">
          <template v-if="selectMenuList(link.name)">
            <template v-if="selectSubMenuList(link.name)">
              <v-list-group :value="false" no-action>
                <template v-slot:activator>
                  <v-list-item-action>
                    <v-icon id="icon" @click.stop="mini = !mini">{{
                      link.icon
                    }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content id="itemContent">
                    {{ link.name }}
                  </v-list-item-content>

                  <template v-if="isParentNewCheck(link.name)">
                    <v-icon id="newIcon">mdi-new-box</v-icon>
                  </template>
                </template>
                <v-list-item
                  v-for="child in link.items"
                  :to="child.route"
                  router
                  :key="child.text"
                >
                  <v-list-item-title v-text="child.name"></v-list-item-title>

                  <template v-if="isNewCheck(child.name)">
                    <v-list-item-icon>
                      <v-icon id="newIcon">mdi-new-box</v-icon>
                    </v-list-item-icon>
                  </template>
                  <template v-else>
                    <v-list-item-icon>
                      <v-icon id="childIcon" v-text="child.icon"></v-icon>
                    </v-list-item-icon>
                  </template>
                </v-list-item>
              </v-list-group>
            </template>

            <template v-else>
              <v-list-item :to="link.route" router>
                <v-list-item-action>
                  <v-icon id="icon">{{ link.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content id="itemContent">
                  {{ link.name }}
                </v-list-item-content>
              </v-list-item>
            </template>
          </template>
        </div>

        <v-list-item @click="LOGOUT" v-if="isAuthenticated">
          <v-list-item-action>
            <v-icon id="icon">mdi-logout-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content> 로그아웃 </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!-- SECTION: 옆쪽 Drawer -->
  </nav>
</template>

<script>
import { eventBus } from "../main.js";

export default {
  name: "AppBar",
  data() {
    return {
      drawer: true,
      mini: false,
      navTopBar: false,
      home: "/",
      links: [
        {
          name: "HOME",
          icon: "mdi-home-circle",
          route: "/",
        },
        // {
        //   name: "방명록",
        //   icon: "mdi-book-open-page-variant",
        //   route: "/visitorsBook",
        // },
        {
          name: "지식창고",
          icon: "mdi-lightbulb",
          items: [
            {
              name: "경제",
              icon: "mdi-finance",
              route: "/Finance",
            },

            {
              name: "부동산",
              icon: "mdi-home-group",
              route: "/RealEstate",
            },
            {
              name: "IT",
              icon: "mdi-monitor-speaker",
              route: "/IT",
            },
            {
              name: "언어학습",
              icon: "mdi-alphabetical",
              route: "/English",
            },
          ],
        },
        {
          name: "게시판",
          icon: "mdi-format-list-bulleted-square",
          items: [
            {
              name: "포럼",
              icon: "mdi-forum",
              route: "/forum",
            },
            {
              name: "오늘의이슈",
              icon: "mdi-folder-star",
              route: "/Issue",
            },
            {
              name: "유머",
              icon: "mdi-emoticon-excited",
              route: "/Humor",
            },
          ],
        },
        {
          name: "블로그",
          icon: "mdi-post",
          items: [
            {
              name: "여행일기",
              icon: "mdi-wallet-travel",
              route: "/Travel",
            },
            {
              name: "감상문",
              icon: "mdi-filmstrip",
              route: "/Comment",
            },
            {
              name: "운동일지",
              icon: "mdi-image-filter-hdr",
              route: "/Exercise",
            },
            {
              name: "봉구일지",
              icon: "mdi-dog",
              route: "/BongGu",
            },
          ],
        },
        {
          name: "개인공간",
          icon: "mdi-wallet-membership",
          items: [
            {
              name: "인규와 소통공간",
              icon: "mdi-notebook",
              route: "/PrivateBulletin",
            },
            {
              name: "일정관리",
              icon: "mdi-calendar-multiple-check",
              route: "/ScheduleMng",
            },
          ],
        },

        {
          name: "로그인",
          icon: "mdi-login",
          route: "/login",
        },
        {
          name: "회원가입",
          icon: "mdi-account-plus",
          route: "/register",
        },
        {
          name: "회원관리",
          icon: "mdi-shield-check",
          route: "/UserManage",
        },
        {
          name: "로그관리",
          icon: "mdi-math-log",
          route: "/LogMonitoring",
        },
        {
          name: "마이페이지",
          icon: "mdi-account",
          route: "/isOkay",
        },
        {
          name: "사이트맵",
          icon: "mdi-sitemap-outline",
          route: "/siteMap",
        },
      ],
    };
  },
  watch: {
    /**
     * Watch 연습
     *  */
    // isDesktop: function (value) {
    //   console.log(this.$refs.leftNavigation.updateMiniVariant);
    //   this.$refs.leftNavigation.updateMiniVariant(false);
    //   if (!value) {
    //     // console.log("here", value);
    //     this.mini = false;
    //   }
    // },
  },
  computed: {
    readOnly() {
      return this.$route.query.readOnly === "true";
    },
    isDesktop() {
      return !this.$vuetify.breakpoint.mobile;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isManager() {
      return this.$store.getters.memberType;
    },
    isToken() {
      return this.$store.getters.token;
    },
    editable() {
      return this.$store.getters.isEditable;
    },
    editableUse() {
      // console.log(this.$store.getters.isEditableUse);
      return this.$store.getters.isEditableUse;
    },
  },

  methods: {
    editDetail() {
      eventBus.$emit("request-edit-detail");
    },
    deleteDetail() {
      eventBus.$emit("request-delete-detail");
    },
    editDetailCancel() {
      eventBus.$emit("request-edit-detail-cancel");
    },
    saveDetail() {
      // this.$parent.$children.map(function (value, key) {
      //   if (value.$options._componentTag === "v-main") {
      //     value.$children[0].saveDetail();
      //   }
      // });
      eventBus.$emit("request-save-detail");
    },
    LOGOUT() {
      this.$store.dispatch("LOG_OUT");
    },
    isNewCheck(name) {
      switch (name) {
        case "경제":
          if (localStorage.getItem("financeBoard") === "true") {
            this.parentNewCheck = true;
            return true;
          } else {
            return false;
          }
          break;
        case "부동산":
          if (localStorage.getItem("realEstateBoard") === "true") {
            this.parentNewCheck = true;
            return true;
          } else {
            return false;
          }
          break;
        case "IT":
          if (localStorage.getItem("it") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "언어학습":
          if (localStorage.getItem("english") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "포럼":
          if (localStorage.getItem("bulletinBoard") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "오늘의이슈":
          if (localStorage.getItem("todayIssue") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "유머":
          if (localStorage.getItem("humor") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "여행일기":
          if (localStorage.getItem("travel") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "감상문":
          if (localStorage.getItem("comment") === "true") {
            this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "운동일지":
          if (localStorage.getItem("exercise") === "true") {
            this.parentNewCheck = true;
            return true;
          } else {
            return false;
          }
          break;
        case "봉구일지":
          if (localStorage.getItem("bongGu") === "true") {
            this.parentNewCheck = true;
            return true;
          } else {
            return false;
          }
          break;
        case "인규와 소통공간":
          if (localStorage.getItem("privateBulletinBoard") === "true") {
            return true;
          } else {
            return false;
          }
          break;
        default:
          return false;
      }
    },
    isParentNewCheck(name) {
      switch (name) {
        case "지식창고":
          if (localStorage.getItem("knowledgeBoard") === "true") {
            // this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;
        case "게시판":
          if (localStorage.getItem("parentBulletinBoard") === "true") {
            // this.parentNewCheck = true;
            return true;
          } else {
            return false;
          }
          break;
        case "블로그":
          if (localStorage.getItem("blog") === "true") {
            // this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
        case "인규와 소통공간":
          if (localStorage.getItem("privateBulletinBoard") === "true") {
            // this.parentNewCheck = true;

            return true;
          } else {
            return false;
          }
          break;

        default:
          return false;
      }
    },

    selectMenuList(name) {
      if (name === "로그인" || name === "회원가입") {
        if (this.isAuthenticated) {
          return false;
        }
      }
      if (name === "회원관리" || name === "로그관리" || name === "매뉴얼") {
        if (this.isManager === "MANAGER" || this.isManager === "ADMIN") {
          return true;
        } else {
          return false;
        }
      }
      if (
        // name === "블로그" ||
        // name === "지식창고" ||
        // name === "게시판" ||
        name === "개인공간" ||
        name === "마이페이지"
      ) {
        if (this.isAuthenticated) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    selectSubMenuList(name) {
      if (
        // name === "지식창고" ||
        // name === "게시판" ||
        // name === "블로그" ||
        name === "개인공간"
      ) {
        if (this.isAuthenticated) {
          return true;
        }
      } else if (
        name === "지식창고" ||
        name === "게시판" ||
        name === "블로그"
      ) {
        return true;
      }

      return false;
    },
  },
};
</script>
<style lang="scss">
.mdi-chevron-down::before {
  color: black;
}
.v-navigation-drawer__content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #5d5d5d;
  background-color: #5d5d5d;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 1px;
}
.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #424242;
  background-color: #424242;
}
#icon {
  color: #5d5d5d;
}
#newIcon {
  color: red;
}
#itemContent {
  font-weight: 800;
}
.navbarNarrow {
  min-height: 50px;
  max-height: 50px;
}
.v-toolbar__content,
.v-toolbar__extension {
  min-height: 50px;
  max-height: 50px;
}
.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  padding-right: 5px;
}
#titleIcon {
  padding: 5px;
}
</style>
